import React from 'react'

interface WidgetTypeIconProps {
  code: string
  size?: number
  className?: string
}

const commonProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
}

const VideoEmbedIcon: React.FC<{ size: number; className?: string }> = ({ size, className }) => (
  <svg {...commonProps} width={size} height={size} className={className} aria-hidden="true">
    <rect x="2" y="4" width="20" height="16" rx="2" ry="2" />
    <polygon points="10 9 16 12 10 15 10 9" fill="currentColor" stroke="none" />
  </svg>
)

const EditorialIcon: React.FC<{ size: number; className?: string }> = ({ size, className }) => (
  <svg {...commonProps} width={size} height={size} className={className} aria-hidden="true">
    <line x1="21" y1="6" x2="3" y2="6" />
    <line x1="21" y1="12" x2="3" y2="12" />
    <line x1="17" y1="18" x2="3" y2="18" />
  </svg>
)

const BannerImageIcon: React.FC<{ size: number; className?: string }> = ({ size, className }) => (
  <svg {...commonProps} width={size} height={size} className={className} aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" stroke="none" />
    <polyline points="21 15 16 10 5 21" />
  </svg>
)

const GoogleAdSlotIcon: React.FC<{ size: number; className?: string }> = ({ size, className }) => (
  <svg {...commonProps} width={size} height={size} className={className} aria-hidden="true">
    <path d="m3 11 18-5v12L3 14v-3z" />
    <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
  </svg>
)

const CarouselIcon: React.FC<{ size: number; className?: string }> = ({ size, className }) => (
  <svg {...commonProps} width={size} height={size} className={className} aria-hidden="true">
    <rect x="6" y="6" width="12" height="12" rx="1" ry="1" />
    <path d="M3 8v8" />
    <path d="M21 8v8" />
  </svg>
)

// A full-width banner frame (sun + mountain read as "image") over rotation dots
// that signal the rotating slides — distinguishing it from banner_image/carousel.
const HeroBannerIcon: React.FC<{ size: number; className?: string }> = ({ size, className }) => (
  <svg {...commonProps} width={size} height={size} className={className} aria-hidden="true">
    <rect x="3" y="4" width="18" height="12" rx="2" ry="2" />
    <circle cx="8" cy="20" r="0.9" />
    <circle cx="12" cy="20" r="0.9" fill="currentColor" stroke="none" />
    <circle cx="16" cy="20" r="0.9" />
  </svg>
)

const WidgetTypeIcon: React.FC<WidgetTypeIconProps> = ({ code, size = 16, className }) => {
  switch (code) {
    case 'video_embed':
      return <VideoEmbedIcon size={size} className={className} />
    case 'editorial':
      return <EditorialIcon size={size} className={className} />
    case 'banner_image':
      return <BannerImageIcon size={size} className={className} />
    case 'google_ad_slot':
      return <GoogleAdSlotIcon size={size} className={className} />
    case 'standard_landscape_carousel':
    case 'standard_portrait_carousel':
    case 'small_landscape_carousel':
    case 'large_landscape_carousel':
      return <CarouselIcon size={size} className={className} />
    case 'hero_banner':
      return <HeroBannerIcon size={size} className={className} />
    default:
      return null
  }
}

export default WidgetTypeIcon
